export const UPDATE_SCREEN_TITLE =
  'app/EditSessionPage/TlfbEvents/UPDATE_SCREEN_TITLE';
export const UPDATE_SCREEN_QUESTION =
  'app/EditSessionPage/TlfbEvents/UPDATE_SCREEN_QUESTION';
